import jwt from "jwt-encode";

// ====== LOCAL STORAGE ======
export const getStorage = (key) => {
  return sessionStorage.getItem(key);
};

export const getStoragelocal = (key) => {
  return localStorage.getItem(key);
};

export const setStorage = (key, value) => {
  return localStorage.setItem(key, value);
};
